const NAME_CHANGE = 'NAME_CHANGE';
const PHONE_CHANGE = 'PHONE_CHANGE';
const EMAIL_CHANGE = 'EMAIL_CHANGE';
const POSITION_CHANGE = 'POSITION_CHANGE';
const LAST_CHANGE = 'LAST_CHANGE';
const SET_CUSTOMER = 'SET_CUSTOMER';
const ERASE_CUSTOMER_CONTACT = 'ERASE_CUSTOMER_CONTACT';

export {
    NAME_CHANGE,
    PHONE_CHANGE,
    EMAIL_CHANGE,
    POSITION_CHANGE,
    LAST_CHANGE,
    SET_CUSTOMER,
    ERASE_CUSTOMER_CONTACT,
};



// WEBPACK FOOTER //
// ./src/containers/AddClient/Contact/constants.js